import { useRouter } from 'next/router';
import React, { useContext, useEffect, useState } from 'react';
import { useGlobalData } from './GlobalDataContext';

const HOME_PAGE = '';
const SEARCH_PAGE = '/search';
const CATEGORY_PAGE = '/categories/[categoryId]';
export const PRODUCT_DETAIL_PAGE = '/products/[sku]';
const LANDING_PAGE = '/landing/[id]';
export const BRAND_PAGE = '/brands/[brandId]';
export const MASTER_CATEGORY_PAGE = '/block-categories/[categoryId]';
const SELLER_CATEGORY_PAGE = '/seller-categories/[categoryId]';
export const SELLER_PAGE = '/sellers/[sellerId]';
const COMBO_LIST = '/products/[sku]/combos';
const COMBO_DETAIL = '/products/[sku]/combos/[id]';
const PROVIDER_PAGE = '/cua-hang/[providerId]';
const LANDING_BUILDER_PAGE = '/p/[slug]';

export const TRACKING_SCREEN_MAPPING: Record<string, string> = {
  [HOME_PAGE]: 'homePage',
  [SEARCH_PAGE]: 'searchProductResult',
  [CATEGORY_PAGE]: 'category',
  [BRAND_PAGE]: 'brandPage',
  [PRODUCT_DETAIL_PAGE]: 'productDetail',
  [LANDING_PAGE]: 'landingPage',
  [MASTER_CATEGORY_PAGE]: 'masterCategoryPage',
  [SELLER_CATEGORY_PAGE]: 'sellerCategoryPage',
  [SELLER_PAGE]: 'sellerPage',
  [COMBO_LIST]: 'comboList',
  [COMBO_DETAIL]: 'comboDetail',
  [PROVIDER_PAGE]: 'providerPage',
  [LANDING_BUILDER_PAGE]: 'landingPage',
};

const getTrackingScreenName = (
  tenant: string,
  isMobile: boolean,
  pathname: string,
) => {
  const platform = isMobile ? 'mobile' : 'desktop';
  const tenantPrefix = `/${tenant}/${platform}`;
  const tenantPrefixDefault = `/default/${platform}`;
  let actualRoute;
  if (pathname.includes(tenantPrefix))
    actualRoute = pathname.replace(tenantPrefix, '');
  else actualRoute = pathname.replace(tenantPrefixDefault, '');
  return TRACKING_SCREEN_MAPPING[actualRoute];
};

export interface ScreenState {
  trackingScreenName?: string;
  setTrackingScreenName?: (val?: string) => void;
}

export interface ScreenProviderProps {
  children: React.ReactNode;
}

const ScreenStateContext = React.createContext<ScreenState>({});

export const ScreenProvider: React.FunctionComponent<ScreenProviderProps> = ({
  children,
}: ScreenProviderProps) => {
  const [trackingScreenName, setTrackingScreenName] = useState<string>();
  const router = useRouter();
  const { tenant, isMobile } = useGlobalData();

  useEffect(() => {
    setTrackingScreenName(
      getTrackingScreenName(tenant, isMobile, router.pathname),
    );
  }, [router]);

  return (
    <ScreenStateContext.Provider
      value={{
        trackingScreenName,
        setTrackingScreenName,
      }}
    >
      {children}
    </ScreenStateContext.Provider>
  );
};

export function useScreen(): ScreenState {
  const context = useContext(ScreenStateContext);
  if (!context) {
    throw new Error(
      'useScreen must be inside a ScreenStateContext with a state value',
    );
  }
  return context;
}
